<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-divider orientation="left">{{ $t('基本信息') }}</a-divider>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-descriptions :col="3">
                <a-descriptions-item :label="$t('用户编号')">{{model.userId}}</a-descriptions-item>
                <a-descriptions-item :label="$t('用户姓名')">{{model.userName}}</a-descriptions-item>
                <a-descriptions-item :label="$t('用户电话')">{{model.userPhone}}</a-descriptions-item>
                <a-descriptions-item :label="$t('申请类型')">{{applyTypeList[model.applyType]}}</a-descriptions-item>
                <a-descriptions-item :label="$t('申请时间')">{{model.createTime}}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :col="1">
                <a-descriptions-item :label="$t('申请原因')">{{model.applyDescription}}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :col="1">
                <a-descriptions-item :label="$t('电子签名')"></a-descriptions-item>
              </a-descriptions>
              <j-image-upload 
                class="avatar-uploader" 
                :text="$t('上传')" 
                :isMultiple="true" 
                v-model="model.applySignature" 
                :disabled="true"
              />
              <!-- <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false">
                <img style="width: 180px;height: 80px;" :src="model.applySignature"/>
                <div class="mask-sig" :class="{'mask-show':isShow}">
                  <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                  <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                </div>
              </div> -->
              <a-descriptions :col="1">
                <a-descriptions-item :label="$t('身份证正反面')"></a-descriptions-item>
              </a-descriptions>
              <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="fileList" :disabled="true"></j-image-upload>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <!-- 用户信息变更 -->
            <a-col :span="24" v-if="model.applyType == 3">
              <a-divider orientation="left">{{ $t('用户信息变更信息') }}</a-divider>
              <a-descriptions :col="3">
                <a-descriptions-item :label="$t('新用户姓名')">{{model.valueJson.userName}}</a-descriptions-item>
                <a-descriptions-item :label="$t('新用户电话')">{{model.valueJson.userPhone}}</a-descriptions-item>
                <a-descriptions-item :label="$t('新用户地址')">{{model.valueJson.userAddr}}</a-descriptions-item>
                <a-descriptions-item :label="$t('新身份证号')">{{model.valueJson.userIdNumber}}</a-descriptions-item>
              </a-descriptions>
            </a-col>
            <!-- 价格信息变更 -->
            <a-col :span="24" v-if="model.applyType == 4">
              <a-divider orientation="left">{{ $t('价格信息变更信息') }}</a-divider>
              <a-descriptions :col="3">
                <a-descriptions-item :label="$t('价格信息')">{{priceList[model.valueJson.newPriceId]}}</a-descriptions-item>
                <a-descriptions-item :label="$t('变更方式')">{{model.valueJson.changeWay==1?$t('立即结算'):model.valueJson.changeWay==2?$t('扣完再启用新价格'):''}}</a-descriptions-item>
                <a-descriptions-item :label="$t('启用日期')">{{model.valueJson.startDate}}</a-descriptions-item>
              </a-descriptions>
            </a-col>
            <!-- 用户过户 -->
            <a-col :span="24" v-if="model.applyType == 5">
              <a-divider orientation="left">{{ $t('用户过户信息') }}</a-divider>
              <a-descriptions :col="3">
                <a-descriptions-item :label="$t('新用户姓名')">{{model.valueJson.userName}}</a-descriptions-item>
                <a-descriptions-item :label="$t('新用户电话')">{{model.valueJson.userPhone}}</a-descriptions-item>
                <a-descriptions-item :label="$t('新用户地址')">{{model.valueJson.userAddr}}</a-descriptions-item>
                <a-descriptions-item :label="$t('新身份证号')">{{model.valueJson.userIdNumber}}</a-descriptions-item>
                <a-descriptions-item :label="$t('价格信息')">{{priceList[model.valueJson.userPriceCode]}}</a-descriptions-item>
                <a-descriptions-item :label="$t('用户类型')">{{userTypeList[model.valueJson.userTypeCode]}}</a-descriptions-item>
                <a-descriptions-item :label="$t('身份类型')">{{model.valueJson.userIdType==1?$t('自然人'):model.valueJson.userIdType==0?$t('企业'):''}}</a-descriptions-item>
                <a-descriptions-item :label="$t('优惠信息')">{{userFreeinfoList[model.valueJson.userFreeinfo]}}</a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('审批意见')" prop="isAgree">
                <a-radio-group v-model="model.isAgree">
                  <a-radio :value="1">{{ $t('通过') }}</a-radio>
                  <a-radio :value="0">{{ $t('驳回') }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('审批描述')" prop="approvalDescription">
                <a-textarea v-model="model.approvalDescription" :placeholder="$t('请输入审批描述')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <j-modal :title="$t('预览')" :width="448" :visible="visibleSig" @cancel="handleSigCancel" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
      <div style="width: 400px;height: 400px;">
        <img :src="model.applySignature" alt="" style="width: 100%;height: 100%;" />
      </div>
    </j-modal>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {PhoneNumberPattern} from '@/utils/regPattern'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    // mixins: [JeecgListMixin],
    name: 'handleModal',
    components: {
      JImageUpload,
      DetailList,
      DetailListItem
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          updateState: "/jeecg-charge/meter/wechatUserApply/updateState",
          priceList: "jeecg-charge/meter/meterPriceinfo/list",
          userTypeList: "/jeecg-charge/meter/meterUserType/list",
          queryById: "/jeecg-charge/meter/wechatUserApply/queryById",
        },
        priceList: {},
        userTypeList: {},
        isShow: false,
        fileList:'',
        visibleSig:false
      }
    },
    computed: {
      validatorRules() {
        return {
          isAgree: [{
            required: true,
            message: this.$t('请选择审批意见'),
            trigger: 'blur'
          }],
          approvalDescription: [{
            required: this.model.isAgree !== 1,
            message: this.$t('请输入审批描述'),
            trigger: 'blur'
          }],
        };
      },
      applyTypeList() {
        return ['报停', '报停恢复', '销户', '用户信息变更', '价格信息变更', '用户过户'].map(item => this.$t(item));
      },
      userFreeinfoList() {
        return {
          1: this.$t('按户'),
          2: this.$t('按人'),
          3: this.$t('按月'),
          4: this.$t('按量')
        };
      },
    },
    methods: {
      viewSig(){
        this.visibleSig = true;
      },
      handleSigCancel(){
        this.visibleSig = false;
      },
      downloadSig(){
        this.downloadFile(this.model.applySignature, this.$t('签名'))
      },
      downloadFile(url, name) {
        console.log('url==', url)
        var a = document.createElement("a")
        a.setAttribute("href", url)
        a.setAttribute("download", name)
        a.setAttribute("target", "_blank")
        let clickEvent = document.createEvent("MouseEvents")
        clickEvent.initEvent("click", true, true)
        a.dispatchEvent(clickEvent)
      },
      getpriceList(){
        this.priceList = {};
        getAction(this.url.priceList).then((res)=>{
          if(res.success){
            res.result.records.map(item=>{
              this.$set(this.priceList, item.id, item.wtName)
            })
          }
        })
      },
      getuserTypeList(){
        this.userTypeList = {};
        getAction(this.url.userTypeList).then((res)=>{
          if(res.success){
            res.result.records.map(item=>{
              this.$set(this.userTypeList, item.id, item.utName)
            })
          }
        })
      },
      init(row){
        this.visible = true;
        this.title = this.$t('审批处理');
        // this.model = JSON.parse(JSON.stringify(row));
        this.model = {};
        // this.model.id = row.id;
        // this.model.userKeyId = row.userKeyId;
        // this.model.applyType = row.applyType;
        // this.model.valueJson = row.valueJson;
        getAction(this.url.queryById,{id:row.id}).then(res=>{
          if(res.success){
            this.model = res.result;
            let userIdCardFront = JSON.parse(this.model.userIdCardFront);
            let userIdCardOpposite = JSON.parse(this.model.userIdCardOpposite);
            this.$nextTick(()=>{
              this.$set(this,'fileList',userIdCardFront.concat(userIdCardOpposite).join(','));
            })
            this.model.valueJson = JSON.parse(this.model.valueJson);
            if(this.model.applyType == 4 || this.model.applyType == 5) this.getpriceList();
            if(this.model.applyType == 5) this.getuserTypeList();
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let params = JSON.parse(JSON.stringify(this.model));
            params.valueJson = JSON.stringify(this.model.valueJson);
            postAction(this.url.updateState, params).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>
<style lang="less" scoped>
  .box-sig{
    width: 200px;
    height: 100px;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius:4px;
    display: flex;
    justify-content: center;
    align-items: center;
    .mask-sig{
      visibility: hidden;
      position: absolute;
      width: 180px;
      height: 80px;
      top: 10px;
      left: 10px;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      cursor: pointer;
      
      .icon-sig{
        color: rgba(255, 255, 255, 0.85);
        font-size: 16px;
      }
    }
    .mask-show{
      visibility: visible;
      transition: all 0.3s;
    }
  }
</style>